module.exports = __webpack_public_path__ + "static/media/spicy-piri-test-mb.42122ae2.jpg";